import React from "react";
import { useTranslation } from "react-i18next";
import TitleSection from "../components/TitleSection/TitleSection";
import ContactForm from "../components/ContactForm";
import { Images } from "../assets";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleSection
        title={t("contact.title")}
        subtitle={t("contact.subtitle")}
        highlightWords={[t("contact.highlightWords")]}
        bgImg={Images.CONTACT_BG_IMAGE}
      />

      <div className="my-10">
        <ContactForm />
      </div>

      <div className="relative mb-5 flex flex-col items-center gap-5 px-5">
        {/* Google Maps Embed */}
        <iframe
          title="Google Maps - Aficor"
          className="w-full h-[50vh] sm:h-[60vh] md:h-[70vh] rounded-xl border-0"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2762.923656217396!2d6.707019177344867!3d46.74292827103867!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478dcde3e1863d95%3A0x7f8d5a5282c0ad47!2sRoute%20du%20Village%201%2C%201409%20Chan%C3%A9az%2C%20Suisse!5e0!3m2!1sen!2sch!4v1700000000000"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        {/* Overlay Box */}
        <div className="lg:absolute bottom-5 right-5 sm:right-10 md:right-20 bg-orange rounded-xl p-3 sm:p-5 w-full sm:w-3/4 md:w-1/2 lg:w-1/4">
          <p className="text-white">{t("contact.overlayText")}</p>
        </div>
      </div>
    </>
  );
};

export default Contact;
